import {
  MY_TODO_LIST_GET,
  TODO_HISTORY_LIST_GET,
  PROJECT_HISTORY_BY_TARGET_GET,
  PRODUCT_CASE_HISTORY_BY_TARGET_GET,
  PROJECT_BY_TARGET_GET,
  PRODUCT_CASE_BY_TARGET_GET,
  PRODUCT_BY_TARGET_GET,
  PRODUCT_HISTORY_BY_TARGET_GET,
  QUOTATION_RELEASE_BY_TARGET_GET,
  QUOTATION_RELEASE_HISTORY_BY_TARGET_GET,
  DOC_RELEASE_BY_TARGET_GET,
  FAQ_RELEASE_BY_TARGET_GET,
  SOFTWARE_MANUAL_DETAIL_BY_TARGET_GET,
  SOFTWARE_DETAIL_BY_TARGET_GET,
  SOFTWARE_PATCH_DETAIL_BY_TARGET_GET,
  SOFTWARE_INFO_TARGET_HISTORY_GET,
  CUSTOMER_BY_TARGET_GET,
  CUSTOMER_HISTORY_LIST_GET,
  QUOTATION_DETAIL_BY_TARGET_GET,
  QUOTATION_DETAIL_BY_HISTORY_GET,
  TODO_RULE_LIST_GET,
} from "src/fetch/url";
import { todoListStatus } from "src/util";
import { curl } from 'zh-common-modules';
import { actionTypes } from "./constants";

export const setMyTodoList = data => ({
  type: actionTypes.SET_MY_TODO_LIST,
  data
});

export const setGlobalTodoList = data => ({
  type: actionTypes.SET_GLOBAL_TODO_LIST,
  data
});

export const setTodoHistoryList = data => ({
  type: actionTypes.SET_TODO_HISTORY_LIST_GET,
  data
});

export const setProjectHistoryByTarget = data => ({
  type: actionTypes.SET_PROJECT_HISTORY_BY_TARGET,
  data
});

export const setProductCaseHistoryByTarget = data => ({
  type: actionTypes.SET_PRODUCT_CASE_HISTORY_BY_TARGET,
  data
});

export const setProjectByTarget = data => ({
  type: actionTypes.SET_PROJECT_BY_TARGET,
  data
});

export const setProductCaseByTarget = data => ({
  type: actionTypes.SET_PRODUCT_CASE_BY_TARGET,
  data
});

export const setProductByTarget = data => ({
  type: actionTypes.SET_PRODUCT_BY_TARGET,
  data
});

export const setProductHistoryByTarget = data => ({
  type: actionTypes.SET_PRODUCT_HISTORY_BY_TARGET,
  data
});

export const setQuotationRealseDetailByTarget = data => ({
  type: actionTypes.SET_QUOTATION_RELEASE_BY_TARGET,
  data
});

export const setQuotationRealseHistoryByTarget = data => ({
  type: actionTypes.SET_QUOTATION_RELEASE_HISTORY_BY_TARGET,
  data,
});

export const setDocDetailByTarget = data => ({
  type: actionTypes.SET_DOC_DETAIL_BY_TARGET,
  data,
});

export const setFaqDetailByTarget = data => ({
  type: actionTypes.SET_FAQ_DETAIL_BY_TARGET,
  data,
});

export const getMyTodoList = (params) => {
  return dispatch => {
    curl
      .get(MY_TODO_LIST_GET, params)
      .then((res) => {
        dispatch(setMyTodoList(res));
        if (params.status === todoListStatus.ING.value && !params.targetType) {
          dispatch(setGlobalTodoList(res));
        }
      });
  };
};

export const getTodoHistoryList = (params, cb) => {
  return dispatch => {
    curl
      .get(TODO_HISTORY_LIST_GET, params)
      .then((res) => {
        dispatch(setTodoHistoryList(res));
        cb?.(res);
      });
  };
};

export const getProjectHistoryByTarget = (params, cb) => {
  return dispatch => {
    curl
      .get(PROJECT_HISTORY_BY_TARGET_GET, params)
      .then((res) => {
        dispatch(setProjectHistoryByTarget(res));
        cb && cb(res);
      });
  };
};

export const getProductCaseHistoryByTarget = (params, cb) => {
  return dispatch => {
    curl
      .get(PRODUCT_CASE_HISTORY_BY_TARGET_GET, params)
      .then((res) => {
        dispatch(setProductCaseHistoryByTarget(res));
        cb?.(res);
      });
  };
};

export const getProjectByTarget = (params, cb) => {
  return dispatch => {
    curl
      .get(PROJECT_BY_TARGET_GET, params)
      .then((res) => {
        dispatch(setProjectByTarget(res));
        cb?.(res);
      });
  };
};

export const getProductCaseByTarget = (params) => {
  return dispatch => {
    curl
      .get(PRODUCT_CASE_BY_TARGET_GET, params)
      .then((res) => {
        dispatch(setProductCaseByTarget(res));
      });
  };
};

export const getProductTarget = (params) => {
  return dispatch => {
    curl
      .get(PRODUCT_BY_TARGET_GET, params)
      .then((res) => {
        dispatch(setProductByTarget(res));
      });
  };
};

export const getProductHistoryTarget = (params, cb) => {
  return dispatch => {
    curl
      .get(PRODUCT_HISTORY_BY_TARGET_GET, params)
      .then((res) => {
        dispatch(setProductHistoryByTarget(res));
        cb?.(res);
      });
  };
};

export const getQuotationDetailTarget = (params) => {
  return dispatch => {
    curl
      .get(QUOTATION_RELEASE_BY_TARGET_GET, params)
      .then((res) => {
        dispatch(setQuotationRealseDetailByTarget(res));
      });
  };
};

export const getQuotationHistoryTarget = (params, cb) => {
  return dispatch => {
    curl
      .get(QUOTATION_RELEASE_HISTORY_BY_TARGET_GET, params)
      .then((res) => {
        dispatch(setQuotationRealseHistoryByTarget(res));
        cb?.(res);
      });
  };
};

export const getDocDetailByTarget = (params) => {
  return dispatch => {
    curl
      .get(DOC_RELEASE_BY_TARGET_GET, params)
      .then((res) => {
        dispatch(setDocDetailByTarget(res));
      });
  };
};

export const getFaqDetailByTarget = (params, cb) => {
  return dispatch => {
    curl
      .get(FAQ_RELEASE_BY_TARGET_GET, params)
      .then((res) => {
        cb && cb(res);
        dispatch(setFaqDetailByTarget(res));
      });
  };
};

/**
 * 审批时获取手册详情
 * @param {*} params 参数
 * @param {*} cb 回调
 * @returns 
 */
export const getManualDetailByTarget = (params, cb) => {
  return dispatch => {
    curl
      .get(SOFTWARE_MANUAL_DETAIL_BY_TARGET_GET, params)
      .then((res) => {
        cb && cb(res);
      });
  };
};

/**
 * 审批的时候获取版本发布详情
 * @param {*} params 参数
 * @param {*} cb 回调
 * @returns 
 */
export const getSoftwareDetailByTarget = (params, cb) => {
  return dispatch => {
    curl
      .get(SOFTWARE_DETAIL_BY_TARGET_GET, params)
      .then((res) => {
        cb && cb(res);
      });
  };
};

/**
 * 审批时获取补丁详情
 * @param {*} params 参数
 * @param {*} cb 回调
 * @returns 
 */
export const getPatchDetailByTarget = (params, cb) => {
  return dispatch => {
    curl
      .get(SOFTWARE_PATCH_DETAIL_BY_TARGET_GET, params)
      .then((res) => {
        cb && cb(res);
      });
  };
};

/**
 * 获取版本发布中，待办所有的操作历史记录
 * @param {*} params 参数
 * @param {*} cb 回调
 * @returns 
 */
export const getSoftwareInfoTargetHistory = (params, cb) => {
  return dispatch => {
    curl
      .get(SOFTWARE_INFO_TARGET_HISTORY_GET, params)
      .then((res) => {
        cb && cb(res);
      });
  };
};

/**
 * 审批时获取客户详情
 * @param {*} params 参数
 * @param {*} cb 回调
 * @returns 
 */
export const getCustomerByTarget = (params, cb) => {
  return dispatch => {
    curl
      .get(CUSTOMER_BY_TARGET_GET, params)
      .then((res) => {
        cb && cb(res);
      });
  };
};

/**
 * 获取客户信息待办所有的操作历史记录
 * @param {*} params 参数
 * @param {*} cb 回调
 * @returns 
 */
export const getCustomerTargetHistory = (params, cb) => {
  return dispatch => {
    curl
      .get(CUSTOMER_HISTORY_LIST_GET, params)
      .then((res) => {
        cb && cb(res);
      });
  };
};

/**
 * 审批时获取报价单详情
 * @param {*} params 参数
 * @param {*} cb 回调
 * @returns 
 */
export const getQuotationByTarget = (params, cb) => {
  return dispatch => {
    curl
      .get(QUOTATION_DETAIL_BY_TARGET_GET, params)
      .then((res) => {
        cb && cb(res);
      });
  };
};

/**
 * 获取报价单待办所有的操作历史记录
 * @param {*} params 参数
 * @param {*} cb 回调
 * @returns 
 */
export const getQuotationTargetHistory = (params, cb) => {
  return dispatch => {
    curl
      .get(QUOTATION_DETAIL_BY_HISTORY_GET, params)
      .then((res) => {
        cb && cb(res);
      });
  };
};

/**
 * 代办分页获取规则列表
 * @param {*} params 参数
 * @param {*} cb 回调
 * @returns 
 */
export const getTodoList = (params, cb) => {
  return dispatch => {
    curl
      .get(TODO_RULE_LIST_GET, params)
      .then((res) => {
        cb && cb(res);
      });
  };
};
